import { render, staticRenderFns } from "./DialogUbicazioniEsistenze.vue?vue&type=template&id=8a88d2f4&"
import script from "./DialogUbicazioniEsistenze.vue?vue&type=script&lang=js&"
export * from "./DialogUbicazioniEsistenze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports